/* eslint-disable react/prop-types */
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";

import ImageUpload from "components/CustomUpload/ImageUpload";
import { SDCloudBackendAPIWithToken } from "apis/backendAPI";
import NotificationAlert from "../Components/NotificationAlert";
import { Api } from "config/api";
const getProfileEmail = () => {
  try {
    const profileData = JSON.parse(localStorage.getItem("profileData"));
    return profileData?.email || "";
  } catch {
    return "";
  }
};

const useStyles = makeStyles((theme) => ({
  btnStyle: {
    background: `${theme.palette.buttonColor.main} !important`,
  },
  imageUploadBtn: {
    background: `${theme.palette.primary.main} !important`,
  },
  uploadContainer: {
    marginTop: "20px",
    border: "1px solid #8C8C8C",
    boxShadow: "0px 4px 4px 0px #000000 25%",
    borderStyle: "dashed",
    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
  },
}));

const Uploader = ({ setFiles }) => {
  const classes = useStyles();

  return (
    <Grid
      className={classes.uploadContainer}
      container
      justify="center"
      alignItems="center"
    >
      <ImageUpload
        fileSelected={setFiles}
        addButtonProps={{
          color: "secondary",
          className: classes.imageUploadBtn,
        }}
        changeButtonProps={{
          color: "secondary",
          className: classes.imageUploadBtn,
        }}
        removeButtonProps={{
          color: "secondary",
          className: classes.imageUploadBtn,
        }}
        addButtonText="Attach files"
      />
    </Grid>
  );
};

export default function HelpSupportRightSideDrawer({ onClosePanel }) {
  const classes = useStyles();
  const { profileObj } = useSelector((state) => state.profileObj);

  const [email, setEmail] = useState(
    getProfileEmail() || profileObj?.email || ""
  );
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [files, setFiles] = useState(null);
  const [errors, setErrors] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("");

  const validateForm = () => {
    const newErrors = {};

    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!subject.trim()) {
      newErrors.subject = "Subject is required.";
    }

    if (!body.trim()) {
      newErrors.body = "Message is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setSubject("");
    setBody("");
    setFiles(null);
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const formData = new FormData();
    formData.append("email", email.trim());
    formData.append("subject", subject.trim());
    formData.append("body", body.trim());

    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append("attachments", files[i]);
      }
    }

    SDCloudBackendAPIWithToken()
      .post(Api.submitSupportEmail, formData)
      .then((resp) => {
        const message =
          resp.data?.message || "Your message has been sent to support.";
        setShowNotification(true);
        setNotificationMessage(message);
        setNotificationType("success");
        resetForm();
        setTimeout(() => {
          if (onClosePanel) onClosePanel();
        }, 3000);
      })
      .catch((err) => {
        const message =
          err.response?.data?.message || "Failed to send your message.";
        setShowNotification(true);
        setNotificationMessage(message);
        setNotificationType("error");
      });
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <form onSubmit={handleSubmit}>
            <TextField
              type="email"
              variant="filled"
              label="Email"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!errors.email}
              helperText={errors.email}
            />
            <TextField
              type="text"
              variant="filled"
              label="Subject"
              fullWidth
              required
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              error={!!errors.subject}
              helperText={errors.subject}
            />
            <TextField
              type="text"
              variant="filled"
              label="Message"
              fullWidth
              required
              multiline
              rows={5}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              error={!!errors.body}
              helperText={errors.body}
            />

            <Uploader setFiles={setFiles} />

            <Button
              variant="contained"
              color="secondary"
              disableElevation
              size="large"
              fullWidth
              className={classes.btnStyle}
              disableFocusRipple
              type="submit"
            >
              Submit
            </Button>

            <NotificationAlert
              notificationType={notificationType}
              showNotification={showNotification}
              message={notificationMessage}
            />
          </form>
        </Grid>
      </Grid>
    </div>
  );
}

